import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  cardNumber: null,
  cvv: null,
  saveCard: false,
  cardEncryptedData: null,
  notes: undefined,
  cardFormValues: {},
  isCardFormComplete: false,
  hasCardError: false,
}

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    paymentPay: () => {},
    paymentUpdate: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    paymentResetCardEncryptedData: state => {
      state.cardEncryptedData = null
      state.cvv = null
      state.cardFormValues = {}
      state.isCardFormComplete = false
      state.hasCardError = false
    },
    setCardFormValues: (state, { payload }) => {
      state.cardFormValues = payload
    },
    setCardFormComplete: (state, { payload }) => {
      state.isCardFormComplete = payload
    },
    setCardFormError: (state, { payload }) => {
      state.hasCardError = payload
    },
  },
})

export const {
  paymentPay,
  paymentUpdate,
  paymentResetCardEncryptedData,
  setCardFormValues,
  setCardFormComplete,
  setCardFormError,
} = paymentSlice.actions

export const paymentSelector = state => state.payment

export default paymentSlice.reducer
